export default __webpack_public_path__ + "static/media/@excellent.9f91260d.svg";